import styled from 'styled-components';
import {Btn} from '../../../ui-toolkit/elements/button/btn-type/Btn';
import {btnColorSetup} from '../../../ui-toolkit/elements/button/btn-setup/btnStyling';
import {colorTheme} from '../../../ui-toolkit/mixin/colorTheme';

export const Toast = styled.div`
    ${colorTheme({
        // === Blue ===
        '--toast-button-background-color': {dark: 'var(--white-00)', light: 'var(--white-00)'},
    })};

    position: fixed;
    bottom: 50px;
    z-index: 9999;
    left: calc((100% + var(--sidebar-width)) / 2);
    transform: translateX(-50%);
    color: var(--white-00);
    padding: 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 800px;
    @media only screen and (min-width: 1200px) {
        width: 100%;
        max-width: 800px;
    }
    @media only screen and (max-width: 1200px) {
        min-width: 600px;
    }
    @media only screen and (max-width: 900px) {
        min-width: 200px;
    }

    ${({color}) => {
        return `
            background: var(--${color});
            border: 1px solid var(--${color}-dark);
            ${Btn}{
                ${btnColorSetup({
                    background: `var(--toast-button-background-color)`,
                    border: `var(--toast-button-background-color)`,
                    txt: `var(--${color})`,
                })};
                &:hover{
                    ${btnColorSetup({
                        background: `var(--toast-button-background-color)`,
                        border: `var(--toast-button-background-color)`,
                        txt: `var(--${color}-dark)`,
                    })};
                }
            }

            `;
    }}
`;
